/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A reply to an offerred agreement.
 */
export enum AgreementOfferReply {
  ACCEPT = "accept",
  REJECT = "reject",
}
